/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpsertVendorChecklistDto } from '../../models/upsert-vendor-checklist-dto';
import { VendorChecklistDto } from '../../models/vendor-checklist-dto';

export interface AsControllerUpsertChecklist$Params {
  clientWorkspaceId: string;
  symptomId: string;
      body: UpsertVendorChecklistDto
}

export function asControllerUpsertChecklist(http: HttpClient, rootUrl: string, params: AsControllerUpsertChecklist$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorChecklistDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerUpsertChecklist.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('symptomId', params.symptomId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorChecklistDto>;
    })
  );
}

asControllerUpsertChecklist.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/checklist';
